module.exports = __webpack_public_path__ + "static/img/01.ad4c26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zongce/01.jpg
// module id = 96rI
// module chunks = 1